<template>
    <div
        ref="addAttachmentModal"
        class="modal fade"
        id="addAttachmentModal"
        tabindex="-1"
        aria-labelledby="addAttachmentModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addAttachmentModalLabel">
                        Add Attachment
                    </h5>
                    <!-- <button
                        type="button"
                        class="btn-close"
                        @click="cancelAddAttachment"
                    ></button> -->
                </div>
                <div class="modal-body">
                    <div class="mb-3">
                        <label for="reasonInput" class="form-label"
                            >Comment for Attachment</label
                        >
                        <textarea
                            class="form-control"
                            id="reasonInput"
                            v-model="order.comment"
                        ></textarea>
                    </div>
                    <div class="col-md-12 mb-3">
                        <label for="description" class="form-label">Attachment</label>
                        <ImageUploader ref="attachFileToOrder" :orderId="order.id" />
                    </div>
                </div>
                <div class="modal-footer">
                    <button 
                        type="button" 
                        class="btn btn-sm btn-outline-danger"
                        @click="cancelAddAttachment"
                    >
                        Cancel
                    </button>
                    <button 
                        type="button" 
                        class="btn btn-sm btn-theme" 
                        :disabled="processing"
                        :class="{'disabled': processing}"
                        v-text="processing ? 'Processing...' : 'Upload'"
                        @click="addAttachment"
                    ></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ImageUploader from "./ImageUploader.vue";
export default {
    name: "AddAttachment",
    components: {
        ImageUploader
    },
    props: {
        orderId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            processing: false,
            order: {
                id: this.orderId,
                comment: '',
                files: []
            }
        }
    },
    methods: {
        addAttachment() {
            const config = {
                headers: { "content-type": "multipart/form-data" },
            };

            // Get the selected files from the image uploader
            this.order.files = this.$refs.attachFileToOrder.files.map((file) => file.file);

            // Check if there are no files selected
            if (this.order.files.length === 0) {
                this.$notification("error","Please select at least one file.");
                return;
            }

            // Enable processing
            this.processing = true;

            axios
                .post("/api/admin/orders/add-attachment",{
                        action_type: "attachment_addded",
                        order_id: this.order.id,
                        comment: this.order.comment,
                        files: this.order.files,
                    },
                    config
                )
                .then((response) => {
                    // Reset the image uploader
                    this.$refs.attachFileToOrder.clearFiles();

                    this.cancelAddAttachment();
                    this.$notification(response.data.status,response.data.message);
                })
                .catch((error) => {
                    this.processing = false;
                    this.$notification("error",error.response.data.message);
                })
                .finally(() => {
                    this.processing = false;
                });
        },
        showModal() {
            $("#addAttachmentModal").modal("show");
        },
        cancelAddAttachment() {
            this.order.files = [];
            this.order.comment = "";
            $("#addAttachmentModal").modal("hide");

            this.$emitter.emit('reset-selected-order');
        }
    }
}
</script>